import { FULL_CIRCLE_ANGLE } from '../constants.js';
import '../math/Graph.js';
import { Point } from '../math/Shapes.js';
import { Matrix } from '../math/Matrix.js';

class Rotation {
    constructor(angle, x, y) {
        this.x = x || 0;
        this.y = y || 0;
        this.angle = angle;
    }
    toString() {
        if (this.x && this.y) {
            return `rotate(${this.angle},${this.x},${this.y})`;
        }
        else {
            return `rotate(${this.angle})`;
        }
    }
    toMatrix() {
        return Matrix.rotation(this.angle, this.x, this.y); // T*R*T^-1
    }
    center() {
        return new Point(this.x, this.y);
    }
    invert() {
        return new Rotation(FULL_CIRCLE_ANGLE - this.angle, this.x, this.y);
    }
    static create(rotation) {
        return new Rotation(rotation.angle, rotation.x, rotation.y);
    }
    static parse(str) {
        const values = str.slice(1, str.length - 1).split(',');
        const angle = parseFloat(values[0]);
        const x = parseFloat(values[1]);
        const y = parseFloat(values[2]);
        return new Rotation(angle, x, y);
    }
}
Rotation.ZERO = new Rotation(0);

export { Rotation };
